// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1OP0N","footer":"ModalFilter_footer__21u3V"};